var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54157 4.67467C5.2249 6.83301 8.33324 10.833 8.33324 10.833V15.833C8.33324 16.2913 8.70824 16.6663 9.16657 16.6663H10.8332C11.2916 16.6663 11.6666 16.2913 11.6666 15.833V10.833C11.6666 10.833 14.7666 6.83301 16.4499 4.67467C16.8749 4.12467 16.4832 3.33301 15.7916 3.33301H4.1999C3.50824 3.33301 3.11657 4.12467 3.54157 4.67467Z",
    fill: "#00E676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFilter);
export default __webpack_public_path__ + "static/media/activeFilter.fd75423899d536de4ad86bd90d301975.svg";
export { ForwardRef as ReactComponent };